import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/workplace-xg/workplace-xg/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Foundation</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Interior architecture</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Space types</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Brand expression</AnchorLink>
  <AnchorLink mdxType="AnchorLink">IBM Global Real Estate</AnchorLink>
    </AnchorLinks>
    <h2>{`Foundation`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM Design Language" href="https://www.ibm.com/design/language/" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/be3a39052a0eec8bce3dd41ca71c2881/eye-bee-m.svg",
            "alt": "Eye bee m"
          }}></img>
        </ResourceCard>
      </Column>
    </Row>
    <h2>{`Interior architecture`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM Workplace Interior Architecture Guide" href="https://ibm.ent.box.com/s/alowmrfztm386balqre6rlj9v1c41g27" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/a9e17b0f1c6890d78aa783ab7ebd38f6/box.svg",
            "alt": "BOX Icon"
          }}></img>
        </ResourceCard>
      </Column>
    </Row>
    <h2>{`Space types`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM Workplace planning and space types" href="https://ibm.ent.box.com/s/suoqvccr6hvlqz6r0v3508j33e9oadux" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/a9e17b0f1c6890d78aa783ab7ebd38f6/box.svg",
            "alt": "BOX Icon"
          }}></img>
        </ResourceCard>
      </Column>
    </Row>
    <h2>{`Brand expression`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM Workplace Design Brand Expression Guide" href="https://ibm.ent.box.com/s/i9vvhd4kg7hmj593oms8zsun9559j3yw" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/a9e17b0f1c6890d78aa783ab7ebd38f6/box.svg",
            "alt": "BOX"
          }}></img>
        </ResourceCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM Workplace Design Signage Guide" href="https://ibm.ent.box.com/s/4nm6sc3p4gfh66wc0u0zp2yysa17zchh" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/a9e17b0f1c6890d78aa783ab7ebd38f6/box.svg",
            "alt": "BOX"
          }}></img>
        </ResourceCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM pictograms library" href="https://www.ibm.com/design/language/iconography/pictograms/library" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/b37bb2ecb04338da06d25a45e56d1116/bee.svg",
            "alt": "Bee"
          }}></img>
        </ResourceCard>
      </Column>
    </Row>
    <h2>{`IBM Global Real Estate`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard subTitle="IBM Global Real Estate" href="https://w3.ibm.com/w3publisher/greworkplace" mdxType="ResourceCard">
          <img {...{
            "src": "/workplace-xg/e73f9cb39d46db58cd110bfbcdf3a775/ibm.svg",
            "alt": "IBM"
          }}></img>
        </ResourceCard>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      